export const SET_TRIAL_CATEGORY = 'SET_TRIAL_CATEGORY';

export interface TrialCategory {
  id: number;
  categoryId: TrialCategoryValue;
  name: string;
  successCertificate?: string;
  failCertificate?: string;
}

export interface TrialCategoryState {
  categories: TrialCategory[];
}

export enum TrialCategoryValue {
  'normal' = 1,
  'voucherTrial' = 4,
  'internalTrial' = 5,
}

interface SetTrialCategoriesAction {
  type: typeof SET_TRIAL_CATEGORY;
  payload: TrialCategory[];
}

export type TrialCategoryActionTypes = SetTrialCategoriesAction;
